import store from '@Store';
import { getCurrentPage } from '@Utils/commonUtils';
import { STORAGE_TYPE, getFromStorage } from '@Service/storageService';

const getLength = values => Object.values(values).filter(val => val.selected).length;
const getActiveKeys = values => {
    const keys = Object.values(values)
        .filter(val => val.selected)
        .map(v => v.text);
    return keys ? keys.join(',') : null;
};

export function getScorecardEventProperties(eventName) {
    const currentPage = getCurrentPage();
    const rootReducer = store.getState();

    if (rootReducer)
        var {
            scoreCard,
            scoreCardFilters,
            document,
            headerNavigation,
            search,
            mixPanel
        } = rootReducer;
    if (scoreCard) var { digAppsFilteredArray, scorecard } = scoreCard;
    if (document) var { userViews, metadata } = document;
    if (scorecard) var { data } = scorecard;
    if (data) var { scoreCardElementList } = data;
    if (scoreCardFilters) {
        var {
            topicFlagsInput,
            subTopicFlagsInput,
            riskFlagsInput,
            AnswersFlagsInput,
            suggestedClauseInput,
            extractionFlagsInput,
            SortFlagsInput
        } = scoreCardFilters;
    }

    const digAppCount = digAppsFilteredArray ? digAppsFilteredArray.length : 0;
    const userViewsCount = userViews ? userViews.length : 0;
    const lastSubmittedDigAppId = getFromStorage('digAppId', STORAGE_TYPE.PROPERTY_BAG);
    const digAppId = lastSubmittedDigAppId ? lastSubmittedDigAppId : 'Not set';

    const { mixpanelTabLoadDuration } = headerNavigation;
    const pageLoadDuration = mixpanelTabLoadDuration ? mixpanelTabLoadDuration : 0;
    const lastSubmissionFileSize = getFromStorage(
        'lastSubmissionFileSize',
        STORAGE_TYPE.PROPERTY_BAG
    );
    const fileSize = `${lastSubmissionFileSize} bytes`;

    const { items } = metadata;
    const totalLabels = items ? items.length : 0;

    const totalTopics = Object.keys(topicFlagsInput).length;
    const totalSubTopics = Object.keys(subTopicFlagsInput).length;

    const riskRules = Object.values(riskFlagsInput).map(flag => ({
        [`Analyzer # ${flag.text} Risk Rules`]: flag.count
    }));
    const riskRulesObject = Object.assign({}, ...riskRules);

    const sortingOnRisk = Object.values(SortFlagsInput).filter(
        flag => flag.opposite && flag.text.includes('Risk') && flag.selected
    ).length;
    const sortingOnTopic = Object.values(SortFlagsInput).filter(
        flag => flag.opposite && flag.text.includes('Topic') && flag.selected
    ).length;

    const { mixpanelSearchDuration } = search;

    if (mixPanel) {
        var {
            riskLevel,
            extractionCount,
            extractionText,
            rulePosition,
            suggestedClauseGroupsCount,
            suggestedClauseInserted,
            initializeStepStartTime,
            analyzingDocumentStartTime,
            generatingScorecardStartTime,
            completionTime,
            loadExistingScorecard
        } = mixPanel.mixpanelScorecard;
    }

    if (mixPanel) {
        var { clauseClickedId } = mixPanel.mixpanelClauses;
    }

    const searchDuration = mixpanelSearchDuration ? mixpanelSearchDuration : 0;
    const totalRules = scoreCardElementList ? scoreCardElementList.length : 0;

    let initializingDuration = 0;
    if (initializeStepStartTime && analyzingDocumentStartTime) {
        initializingDuration =
            analyzingDocumentStartTime.getTime() - initializeStepStartTime.getTime();
    }

    let analyzingDuration = 0;
    if (analyzingDocumentStartTime && generatingScorecardStartTime) {
        analyzingDuration =
            generatingScorecardStartTime.getTime() - analyzingDocumentStartTime.getTime();
    }

    let generatingDuration = 0;
    if (generatingScorecardStartTime && completionTime) {
        generatingDuration = completionTime.getTime() - generatingScorecardStartTime.getTime();
    }

    switch (eventName) {
        case 'Start Page Displayed':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Configured Scorecards': digAppCount,
                'Analyzer # Configured Label Views': userViewsCount,
                'Analyzer # Scorecard Id': digAppId
            };
        case 'Scorecard render time':
            return {
                'Analyzer Display Mode': currentPage,
                'Scorecard rendering time (ms)': pageLoadDuration,
                'Analyzer # Total Rules': totalRules,
                'Analyzer # Scorecard Id': digAppId
            };
        case 'Rule card clicked Show on Document':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Total Rules': totalRules,
                'Analyzer Rule Position': rulePosition,
                'Analyzer Rule # Extractions': extractionCount,
                'Analyzer Rule Risk Level': riskLevel,
                'Search time in ms': searchDuration,
                'Nr characters in extraction clicked': extractionText ? extractionText.length : 0
            };
        case 'Scorecard filters barchart':
        case 'Scorecard filters applied':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Topics': totalTopics,
                'Analyzer # Subtopics': totalSubTopics,
                ...riskRulesObject,
                'Analyzer # Total Rules': totalRules,
                'Analyzer # Total Labels': totalLabels,
                'Analyzer # Scorecard Id': digAppId,
                'Filter on Risk': getActiveKeys(riskFlagsInput),
                'Filter on Topic': getLength(topicFlagsInput),
                'Filter on  Subtopic': getLength(subTopicFlagsInput),
                'Filter on Answer text': getActiveKeys(AnswersFlagsInput),
                'Filter on Has extractions': getActiveKeys(extractionFlagsInput),
                'Filter on Has suggested clause': getActiveKeys(suggestedClauseInput),
                'Filter Sorting on Risk': sortingOnRisk,
                'Filter Sorting on Topic': sortingOnTopic
            };
        case 'Scorecard filters reset':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Topics': totalTopics,
                'Analyzer # Subtopics': totalSubTopics,
                'Analyzer # Total Rules': totalRules,
                'Analyzer # Total Labels': totalLabels,
                'Analyzer # Scorecard Id': digAppId
            };
        case 'Insert linked clause':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Total Rules': totalRules,
                'Analyzer Rule Position': rulePosition,
                'Analyzer Rule # Extractions': extractionCount,
                'Analyzer Rule Risk Level': riskLevel,
                'Nr of suggested clause groups': suggestedClauseGroupsCount,
                'Selected clause group': clauseClickedId,
                'Suggested clause inserted': suggestedClauseInserted
            };
        case 'Show linked clauses':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Total Rules': totalRules,
                'Analyzer Rule Position': rulePosition,
                'Analyzer Rule # Extractions': extractionCount,
                'Analyzer Rule Risk Level': riskLevel,
                'Nr of suggested clause groups': suggestedClauseGroupsCount
            };
        case 'Initializing step complete':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer Wait Time (ms)': initializingDuration,
                'Analyzer # Scorecard Id': digAppId,
                'Document Size': fileSize
            };
        case 'Analyzing step complete':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer Wait Time (ms)': analyzingDuration,
                'Analyzer # Scorecard Id': digAppId,
                'Document Size': fileSize
            };
        case 'Generating Scorecard step complete':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer Wait Time (ms)': generatingDuration,
                'Analyzer # Scorecard Id': digAppId,
                'Document Size': fileSize
            };
        case 'Results displayed':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Configured Scorecards': digAppCount,
                'Analyzer # Configured Label Views': userViewsCount,
                ...riskRulesObject,
                'Analyzer # Total Rules': totalRules,
                'Analyzer # Total Labels': totalLabels,
                'Analyzer # Load existing scorecard': loadExistingScorecard
            };
        case 'Rule card expanded':
        case 'Rule card collapsed':
        case 'Rule card hover on question for tooltip':
        case 'Rule card hover on description for tooltip':
        case 'Rule card extractions cycle key clicked':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Total Rules': totalRules,
                'Analyzer Rule Position': rulePosition,
                'Analyzer Rule # Extractions': extractionCount,
                'Analyzer Rule Risk Level': riskLevel
            };
        default:
            return { 'Mixpanel Error': 'Missing case statement' };
    }
}

export function getClauseLibraryEventProperties(eventName) {
    const currentPage = getCurrentPage();
    const lastSubmittedDigAppId = getFromStorage('digAppId', STORAGE_TYPE.PROPERTY_BAG);
    const digAppId = lastSubmittedDigAppId ? lastSubmittedDigAppId : 'Not set';

    const rootReducer = store.getState();

    const { mixPanel } = rootReducer;

    const {
        clausesInGroupCount,
        subgroupsInGroupCount,
        clauseClickedId,
        totalNumberParentClauseGroups,
        totalNumberClauseGroups,
        totalNumberClauses,
        maxDepth,
        numberClauseGroupsAfterFilter
    } = mixPanel.mixpanelClauses;

    switch (eventName) {
        case 'Detailed clause view Insert clause':
        case 'Detailed clause Toggle show full description':
        case 'Detailed clause Toggle show full text':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                '# Clauses in group': clausesInGroupCount,
                'Clause # clicked': clauseClickedId
            };
        case 'Clause library Displayed':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Total # Parent clause groups': totalNumberParentClauseGroups,
                'Total # Clause groups': totalNumberClauseGroups,
                'Total # Clauses': totalNumberClauses,
                'Max depth': maxDepth
            };
        case 'Clause library filter applied':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Total # Parent clause groups': totalNumberParentClauseGroups,
                'Total # Clause groups': totalNumberClauseGroups,
                'Total # Clauses': totalNumberClauses,
                'Max depth': maxDepth,
                '# clause groups displayed after filter applied': numberClauseGroupsAfterFilter
            };
        case 'Clause library Expand group':
        case 'Clause library Show Clause details':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                '# Sub groups': subgroupsInGroupCount,
                '# clauses in group': clausesInGroupCount
            };
        default:
            return { 'Mixpanel Error': 'Missing case statement' };
    }
}

export function getContractsEventProperties(eventName) {
    const currentPage = getCurrentPage();

    const rootReducer = store.getState();
    if (rootReducer) var { mixPanel } = rootReducer;
    if (mixPanel) var { mixpanelContracts } = mixPanel;
    if (mixpanelContracts) var { fileType, uploadedByMe } = mixpanelContracts;

    switch (eventName) {
        case 'Search contract solr':
        case 'Search contract click on contract':
        case 'Search contract export to docx':
        case 'Search contract copy download link':
            return {
                'Analyzer Display Mode': currentPage
            };
        case 'Search contract download contract':
            return {
                'Analyzer Display Mode': currentPage,
                'File type': fileType
            };
        case 'Search contract name':
            return {
                'Analyzer Display Mode': currentPage,
                'Uploaded by me': uploadedByMe
            };
        default:
            return { 'Mixpanel Error': 'Missing case statement' };
    }
}

export function getLabelsEventProperties(eventName) {
    const currentPage = getCurrentPage();

    const rootReducer = store.getState();
    if (rootReducer) var { document, mixPanel } = rootReducer;
    if (document) var { metadata } = document;
    if (mixPanel) var { mixpanelLabels } = mixPanel;
    if (mixpanelLabels)
        var {
            displayId,
            labelPosition,
            numberOfExtractions,
            numberOfExtractionChars,
            numberOfCharsInExtraction,
            labelViewId
        } = mixpanelLabels;
    const { items } = metadata;
    const totalLabels = items ? items.length : 0;

    const lastSubmittedDigAppId = getFromStorage('digAppId', STORAGE_TYPE.PROPERTY_BAG);
    const digAppId = lastSubmittedDigAppId ? lastSubmittedDigAppId : 'Not set';

    switch (eventName) {
        case 'Label expanded':
        case 'Label collapsed':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer Display Id': displayId,
                'Analyzer # Total Labels': totalLabels,
                'Analyzer Label Position': labelPosition,
                'Analyzer Label # Extractions': numberOfExtractions,
                'Analyzer Label # Characters Shown': numberOfExtractionChars
            };
        case 'Label clicked Show on Document':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer Display Id': displayId,
                'Analyzer # Total Labels': totalLabels,
                'Analyzer Label Position': labelPosition,
                'Analyzer Label # Extractions': numberOfExtractions,
                'Analyzer Label # Characters': numberOfCharsInExtraction
            };
        case 'Select view':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Analyzer # Labelview Id': labelViewId
            };
        default:
            return { 'Mixpanel Error': 'Missing case statement' };
    }
}

export function getMarkupEventProperties(eventName) {
    const currentPage = getCurrentPage();

    const rootReducer = store.getState();
    if (rootReducer) var { mixPanel } = rootReducer;
    if (mixPanel) var { mixpanelMarkup } = mixPanel;

    if (mixpanelMarkup) {
        var { risksToShow, skipTrackChanges } = mixpanelMarkup;
    }

    const lastSubmittedDigAppId = getFromStorage('digAppId', STORAGE_TYPE.PROPERTY_BAG);
    const digAppId = lastSubmittedDigAppId ? lastSubmittedDigAppId : 'Not set';

    switch (eventName) {
        case 'Markup Apply':
        case 'Markup CC done':
        case 'Markup Events Binding done':
            return {
                'Analyzer Display Mode': currentPage,
                'Analyzer # Scorecard Id': digAppId,
                'Risks to show': risksToShow,
                'Skip track changes': skipTrackChanges
            };
        default:
            return { 'Mixpanel Error': 'Missing case statement' };
    }
}
